<template>
  <div
    class="w-50 text-xs break-words"
    :class="{ 'text-error': showDeclineDescription }"
  >
    {{ description }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { PLACEMENT_STATUS_DECLINED } from "@/helpers/constants";

import type { ILenderPlacement } from "@/models/funders";
import type { PropType } from "vue";

const props = defineProps({
  model: {
    type: Object as PropType<ILenderPlacement>,
  },
});

const declineDescription = computed(() => props.model?.decline_reason ?? null);
const showDeclineDescription = computed(
  () =>
    declineDescription.value &&
    props.model?.status === PLACEMENT_STATUS_DECLINED
);
const description = computed(() =>
  showDeclineDescription.value ? declineDescription?.value : "-"
);
</script>
